import React from "react";
import { introductionPageAssetConfig } from "../../../data/introduction/index"
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";

interface IframeworkIntroduction {
    data: {}
}

export const frameworkIntroduction: IframeworkIntroduction = {
    data: {
        "COMPONENTS": [
            {
                "name": "backgroundImageOfIntroductionPage",
                "image": "backgroundImageOfIntro",
                "type": "Image",
                "class": "",
                "visible": true,
                "width": 1920,
                "height": 1080,
                "x": 0,
                "y": 0,
            },
            {
                "name": "backgroundImageOfIntroductionPage_portrait",
                "image": "backgroundImageOfIntroPortrait",
                "type": "Image",
                "class": "",
                "layout": true,
                "uimode": "mobile",
                // "anchor": [0.5, 0.5],
                "visible": false,
                "width": 1080,
                "height": 1920,
                "x": 0,
                "y": 0,
            },
            {
                "name": "backgroundBlackImageForPortrait",
                "image": "backgroundBlackImageForPortrait",
                "type": "Image",
                "class": "",
                "visible": false,
                "width": 1080,
                "height": 986,
                "x": 0,
                "y": 500,
            },

            {
                "id": "landscapeContent",
                "name": "landscapeContent",
                "type": "Container",
                "class": "",
                "x": 0,
                "y": 0,
                "visible": true,
                "filterTypes": [],
                "parentLayer": "baseLayer",
                child: [
                    {
                        "id": "assetsContainerOfIntroWithoutBg",
                        "name": "assetsContainerOfIntroWithoutBg",
                        "type": "Container",
                        "class": "",
                        "x": 0,
                        "y": 0,
                        "filterTypes": [],
                        "parentLayer": "baseLayer",
                        child: [
                            {
                                "name": "post_intro_logo",
                                "image": "post_intro_logo",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 412,
                                "height": 292,
                                "x": 760,
                                "y": 9,
                            },
                            {
                                id: "postIntro_Page1",
                                "name": "postIntro_Page1",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 0,
                                "y": 0,
                                "width": 1920,
                                "height": 1080,
                                "filterTypes": [],
                                child: [
                                    {
                                        "name": "randomWild_sym",
                                        "image": "randomWild_sym",
                                        "type": "Image",
                                        "class": "",
                                        "visible": true,
                                        "width": 554,
                                        "height": 554,
                                        "x": 66,
                                        "y": 320,
                                    },
                                    {
                                        "name": "wild_sym",
                                        "image": "wild_sym",
                                        "type": "Image",
                                        "class": "",
                                        "visible": true,
                                        "width": 554,
                                        "height": 554,
                                        "x": 1306,
                                        "y": 320,
                                    },
                                    {
                                        "id": "unlimitedMultiplierText",
                                        "name": "unlimitedMultiplierText",
                                        "type": "Text",
                                        "width": 590,
                                        "height": 330,
                                        "x": 690,
                                        "y": 433,
                                        "text": "introPage2",
                                        "scaleToFit": false,
                                        "visible": true,

                                        "anchor": [0, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Impact',
                                            fontSize: 96,
                                            fontStyle: 'bold',
                                            fill: ['#bb5a2b', '#ffff51'],
                                            /*   wordWrap: true,
                                              wordWrapWidth: 200, */
                                            stroke: '#950707',
                                            strokeThickness: 3,
                                            dropShadow: true,
                                            dropShadowColor: '#000000',
                                            dropShadowAngle: Math.PI / 2,
                                            dropShadowDistance: 6,

                                        },
                                        "parentLayer": "specialAnimationLayer",
                                    },
                                    {
                                        "name": "unlimitedMultiplier",
                                        "image": "unlimitedMultiplier",
                                        "type": "Image",
                                        "class": "",
                                        "visible": true,
                                        "width": 343,
                                        "height": 180,
                                        "x": 803,
                                        "y": 633,
                                    },


                                    {
                                        "id": "giantWildTextImage",
                                        "name": "giantWildTextImage",
                                        "type": "Text",
                                        "width": 360,
                                        "height": 57,
                                        "x": 1435,
                                        "y": 258,
                                        "text": "introPage3",
                                        "scaleToFit": true,
                                        "visible": true,

                                        "anchor": [0, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Impact',
                                            fontSize: 62,
                                            fontStyle: 'bold',
                                            fill: ['#bb5a2b', '#ffff51'],
                                            /*   wordWrap: true,
                                              wordWrapWidth: 200, */
                                            stroke: '#950707',
                                            strokeThickness: 3,
                                            dropShadow: true,
                                            dropShadowColor: '#000000',
                                            dropShadowAngle: Math.PI / 2,
                                            dropShadowDistance: 6,

                                        },
                                        "parentLayer": "specialAnimationLayer",
                                    },
                                    {
                                        "id": "randomWildTextImage",
                                        "name": "randomWildTextImage",
                                        "type": "Text",
                                        "width": 360,
                                        "height": 57,
                                        "x": 168,
                                        "y": 258,
                                        "text": "introPage1",
                                        "scaleToFit": true,
                                        "visible": true,

                                        "anchor": [0, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Impact',
                                            fontSize: 62,
                                            fontStyle: 'bold',
                                            fill: ['#bb5a2b', '#ffff51'],
                                            /*   wordWrap: true,
                                              wordWrapWidth: 200, */
                                            stroke: '#950707',
                                            strokeThickness: 3,
                                            dropShadow: true,
                                            dropShadowColor: '#000000',
                                            dropShadowAngle: Math.PI / 2,
                                            dropShadowDistance: 6,

                                        },
                                        "parentLayer": "specialAnimationLayer",
                                    },

                                ]

                            },

                            {
                                "id": "radio_button_off",
                                "name": "radio_button_off",
                                "image": "continueButtonOfIntro",
                                "type": objectTypes.Sprite,
                                "interactive": false,
                                "x": 80,
                                "y": 976,
                                "width": 97,
                                "height": 54,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'radiobtn_off.png',
                                    out: 'radiobtn_off.png',
                                    down: 'radiobtn_off.png',
                                    disable: 'radiobtn_off.png',
                                    enable: 'radiobtn_off.png',
                                    hover: 'radiobtn_off.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "radio_button_on",
                                "name": "radio_button_on",
                                "image": "continueButtonOfIntro",
                                "type": objectTypes.Sprite,
                                "interactive": false,

                                "x": 80,
                                "y": 976,
                                "width": 97,
                                "height": 54,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'radiobtn_on.png',
                                    out: 'radiobtn_on.png',
                                    down: 'radiobtn_on.png',
                                    disable: 'radiobtn_on.png',
                                    enable: 'radiobtn_on.png',
                                    hover: 'radiobtn_on.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },







                            {
                                "id": "Button_1_desktop",
                                "name": "postIntro_continueButton",
                                "image": "continueButtonOfIntro",
                                "type": objectTypes.Sprite,
                                "interactive": false,
                                "x": 1677,
                                "y": 976,
                                "width": 167,
                                "height": 59,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'continue_up.png',
                                    out: 'continue_up.png',
                                    down: 'continue_over.png',
                                    disable: 'continue_up.png',
                                    enable: 'continue_up.png',
                                    hover: 'continue_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },


                            {
                                "id": "text_1_desktop",
                                "name": "Text_Continue",
                                "type": "Text",
                                "x": 1760,
                                "y": 1005,
                                "visible": true,
                                "text": "continueIntroText",
                                "anchor": [0.5, 0.5],
                                "width": 280,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Oswald-Regular',
                                    fontSize: 24,
                                    fill: ['#083910'],

                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            {
                                "id": "displayOnLoad",
                                "name": "displayOnLoadText",
                                "type": "Text",
                                "x": 200,
                                "y": 1005,
                                "visible": true,
                                "text": "help-screen_prevent-display",
                                "anchor": [0, 0.5],
                                "width": 280,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Oswald-Regular',
                                    fontSize: 24,
                                    fill: ['#ffffff'],

                                },
                                "parentLayer": "specialAnimationLayer",
                            },




                        ]
                    },

                ]
            },



            {
                "id": "portraitContent",
                "name": "portraitContent",
                "type": "Container",
                "class": "",
                "x": 262,
                "y": 0,
                "visible": false,
                "filterTypes": [],
                "parentLayer": "baseLayer",
                child: [
                    {
                        "id": "assetsContainerOfIntroWithoutBg",
                        "name": "assetsContainerOfIntroWithoutBg",
                        "type": "Container",
                        "class": "",
                        "x": 0,
                        "y": 0,
                        "filterTypes": [],
                        "parentLayer": "baseLayer",
                        child: [
                            {
                                "name": "post_intro_logo",
                                "image": "post_intro_logo",
                                "type": "Image",
                                "class": "",
                                "visible": true,
                                "width": 412,
                                "height": 292,
                                "x": 59,
                                "y": 312,
                            },
                            {
                                id: "postIntro_Page1",
                                "name": "postIntro_Page1",
                                "type": "Container",
                                "class": "",
                                "visible": true,
                                "x": 0,
                                "y": 0,
                                "width": 1920,
                                "height": 1080,
                                "filterTypes": [],
                                child: [
                                    {
                                        "name": "randomWild_sym",
                                        "image": "randomWild_sym",
                                        "type": "Image",
                                        "class": "",
                                        "visible": true,
                                        "width": 554,
                                        "height": 554,
                                        "x": 586,
                                        "y": 1302,
                                    },
                                    {
                                        "name": "wild_sym",
                                        "image": "wild_sym",
                                        "type": "Image",
                                        "class": "",
                                        "visible": true,
                                        "width": 554,
                                        "height": 554,
                                        "x": -293,
                                        "y": 679,
                                    },
                                    {
                                        "id": "unlimitedMultiplierText",
                                        "name": "unlimitedMultiplierText",
                                        "type": "Text",
                                        "width": 500,
                                        "height": 330,
                                        "x": 76,
                                        "y": 1125,
                                        "text": "introPage2",
                                        "scaleToFit": true,
                                        "visible": true,

                                        "anchor": [0, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Impact',
                                            fontSize: 92,
                                            fontStyle: 'bold',
                                            fill: ['#bb5a2b', '#ffff51'],
                                            /*   wordWrap: true,
                                              wordWrapWidth: 200, */
                                            stroke: '#950707',
                                            strokeThickness: 3,
                                            dropShadow: true,
                                            dropShadowColor: '#000000',
                                            dropShadowAngle: Math.PI / 2,
                                            dropShadowDistance: 6,

                                        },
                                        "parentLayer": "specialAnimationLayer",
                                    },
                                    {
                                        "name": "unlimitedMultiplier",
                                        "image": "unlimitedMultiplier",
                                        "type": "Image",
                                        "class": "",
                                        "visible": true,
                                        "width": 343,
                                        "height": 180,
                                        "x": 121,
                                        "y": 1212,
                                    },



                                    {
                                        "id": "giantWildTextImage",
                                        "name": "giantWildTextImage",
                                        "type": "Text",
                                        "width": 360,
                                        "height": 57,
                                        "x": 156,
                                        "y": 838,
                                        "text": "introPage3",
                                        "scaleToFit": true,
                                        "visible": true,

                                        "anchor": [0, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Impact',
                                            fontSize: 62,
                                            fontStyle: 'bold',
                                            fill: ['#bb5a2b', '#ffff51'],
                                            /*   wordWrap: true,
                                              wordWrapWidth: 200, */
                                            stroke: '#950707',
                                            strokeThickness: 3,
                                            dropShadow: true,
                                            dropShadowColor: '#000000',
                                            dropShadowAngle: Math.PI / 2,
                                            dropShadowDistance: 6,

                                        },
                                        "parentLayer": "specialAnimationLayer",
                                    },
                                    {
                                        "id": "randomWildTextImage",
                                        "name": "randomWildTextImage",
                                        "type": "Text",
                                        "width": 360,
                                        "height": 57,
                                        "x": 154,
                                        "y": 1474,
                                        "text": "introPage1",
                                        "scaleToFit": true,
                                        "visible": true,
                                        "anchor": [0, 0.5],
                                        "textStyle": {
                                            fontFamily: 'Impact',
                                            fontSize: 62,
                                            fontStyle: 'bold',
                                            fill: ['#bb5a2b', '#ffff51'],
                                            /*   wordWrap: true,
                                              wordWrapWidth: 200, */
                                            stroke: '#950707',
                                            strokeThickness: 3,
                                            dropShadow: true,
                                            dropShadowColor: '#000000',
                                            dropShadowAngle: Math.PI / 2,
                                            dropShadowDistance: 6,

                                        },
                                        "parentLayer": "specialAnimationLayer",
                                    },

                                ]

                            },


                            {
                                "id": "radio_button_off",
                                "name": "radio_button_off_mobilePortrait",
                                "image": "continueButtonOfIntro",
                                "type": objectTypes.Sprite,
                                "interactive": false,
                                "layout": true,
                                "uimode": "mobile",
                                "x": -281,
                                "y": 1900,
                                "width": 97,
                                "height": 54,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'radiobtn_off.png',
                                    out: 'radiobtn_off.png',
                                    down: 'radiobtn_off.png',
                                    disable: 'radiobtn_off.png',
                                    enable: 'radiobtn_off.png',
                                    hover: 'radiobtn_off.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "radio_button_on",
                                "name": "radio_button_on_mobilePortrait",
                                "image": "continueButtonOfIntro",
                                "type": objectTypes.Sprite,
                                "interactive": false,
                                "layout": true,
                                "uimode": "mobile",
                                "x": -281,
                                "y": 1900,
                                "width": 97,
                                "height": 54,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'radiobtn_on.png',
                                    out: 'radiobtn_on.png',
                                    down: 'radiobtn_on.png',
                                    disable: 'radiobtn_on.png',
                                    enable: 'radiobtn_on.png',
                                    hover: 'radiobtn_on.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },



                            {
                                "id": "Button_1_mobile",
                                "name": "postIntro_continueButtonPortrait",
                                "image": "continueButtonOfIntro",
                                "type": objectTypes.Sprite,
                                "interactive": false,
                                "layout": true,
                                "uimode": "mobile",
                                "x": 821,
                                "y": 1900,
                                "width": 167,
                                "height": 59,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'continue_up.png',
                                    out: 'continue_up.png',
                                    down: 'continue_down.png',
                                    disable: 'continue_disable.png',
                                    enable: 'continue_up.png',
                                    hover: 'continue_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },






                            {
                                "id": "displayOnLoad",
                                "name": "displayOnLoadText_mobile",
                                "type": "Text",
                                "x": -150,
                                "y": 1930,
                                "layout": true,
                                "uimode": "mobile",
                                "visible": true,
                                "text": "displayOnLoadText",
                                "anchor": [0, 0.5],
                                "width": 280,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Oswald-Regular',
                                    fontSize: 24,
                                    fill: ['#ffffff'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            {
                                "id": "text_1_mobile",
                                "name": "Text_Continue_mobile",
                                "type": "Text",
                                "x": 906,
                                "y": 1930,
                                "layout": true,
                                "uimode": "mobile",
                                "visible": true,
                                "text": "continueIntroText",
                                "anchor": [0.5, 0.5],
                                "width": 280,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Oswald-Regular',
                                    fontSize: 24,
                                    fill: ['#083910'],

                                },
                                "parentLayer": "specialAnimationLayer",
                            },

                        ]
                    },

                ]
            },

        ],
    }

};
export const introductionConfigurationContext = React.createContext(
    {}
);